import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import { Container } from "react-bootstrap";

export default class Success extends Component {
  render() {
    return (
      <div>
        <Container>
          <Row style={{ marginTop: 20 }}>
            <h4
              style={{
                color: "red",
                textAlign: "center",
                fontSize: 36,
                fontFamily: "fantasy",
                letterSpacing: 5,
              }}
            >
              {" "}
              OUR SUCCESS STORIES
            </h4>
            <h5 style={{ color: "red", fontWeight: "bold" }}>
              Celebrating the Future of Healthcare
            </h5>
            <p style={{ color: "#00072D" }}>
              Our Convocation Ceremony is more than a graduation — it is a
              celebration of dedication, resilience, and the beginning of
              impactful careers in medical and healthcare services. Each year,
              we proudly honor students who have successfully completed their
              professional training and are ready to serve communities with
              skill and compassion.
            </p>
          </Row>
          <Row>
            <h5 style={{ color: "red", fontWeight: "bold" }}>
              A Milestone Achievement in Medical & Healthcare Education
            </h5>
            <p style={{ color: "#00072D" }}>
              Our students have successfully completed rigorous programs in:
              <ul style={{ marginTop: 10, color: "#00072D" }}>
                <li style={{ listStyleType: "square" }}>General Duty Assistance</li>
                <li style={{ listStyleType: "square" }}>Bedside Assistance</li>
                <li style={{ listStyleType: "square" }}>Operation Theatre Technician Assistance</li>
                <li style={{ listStyleType: "square" }}>Lab Technician Assistance</li>
              </ul>
            </p>
            <p style={{ color: "#00072D", marginTop: "-20px" }}>
              Through hands-on clinical training, hospital internships,
              simulation labs, and community outreach programs, our students
              have transformed from learners into confident healthcare
              professionals.
            </p>

            <h5 style={{ color: "red", fontWeight: "bold" }}>
              Inspiring Student Journeys
            </h5>
            <h6 style={{ color: "red", fontStyle: "italic" }}>
              From Classroom to Clinical Excellence
            </h6>
            <p style={{ color: "#00072D" }}>
              Many of our students are now working in reputed hospitals,
              diagnostic centers, and healthcare facilities across Hyderabad.
              Their success stories reflect:
              <ul style={{ marginTop: 10, color: "#00072D" }}>
                <li style={{ listStyleType: "square" }}>Strong clinical skills</li>
                <li style={{ listStyleType: "square" }}>Ethical patient care</li>
                <li style={{ listStyleType: "square" }}>Leadership in healthcare teams</li>
                <li style={{ listStyleType: "square" }}>Commitment to lifelong learning</li>
              </ul>
            </p>

            <h6
              style={{ color: "red", fontStyle: "italic", marginTop: "-20px" }}
            >
              Example Success Story:
            </h6>
            <p>
              <p
                style={{
                  color: "#00072D",
                  fontStyle: "italic",
                  fontWeight: "bold",
                }}
              >
                “Completing my training here gave me both knowledge and
                confidence. Today, I proudly serve as a staff nurse in a
                multi-specialty hospital, knowing that my education prepared me
                for real-world challenges.”
              </p>
              <ul style={{ marginTop: 10, color: "#00072D" }}>
                <li style={{ listStyleType: "square" }}>
                  Sripathi Madhavi, Medical & Healthcare Services Training
                </li>
                <li style={{ listStyleType: "square" }}>
                  Gunde Kavitha, Medical & Healthcare Services Training
                </li>
                <li style={{ listStyleType: "square" }}>
                  Tasleem Begum, Medical & Healthcare Services Training
                </li>
              </ul>
            </p>

            <h5 style={{ color: "red", fontWeight: "bold" }}>
              Placement & Career Success
            </h5>
            <p style={{ color: "#00072D" }}>
              Our placement support team actively connects graduates with:
              <ul style={{ marginTop: 10, color: "#00072D" }}>
               <li style={{ listStyleType: "square" }}>Multi-specialty Hospitals</li>
                <li style={{ listStyleType: "square" }}>Private & Government Healthcare Centers</li>
                <li style={{ listStyleType: "square" }}>Diagnostic Laboratories</li>
                <li style={{ listStyleType: "square" }}>Community Health Organizations</li>
                <li style={{ listStyleType: "square" }}>Emergency & Trauma Units</li>
              </ul>
            </p>
            <p style={{ color: "#00072D", marginTop: "-20px" }}>
              A significant percentage of our students secure employment within
              months of training, reflecting the quality and industry relevance
              of our training programs.
            </p>

            <h5 style={{ color: "red", fontWeight: "bold" }}>
              Convocation Highlights
            </h5>
            <p style={{ color: "#00072D" }}>
              <ul style={{ marginTop: 10, color: "#00072D" }}>
                <li style={{ listStyleType: "square" }}>Awarding of Certificates</li>
                <li style={{ listStyleType: "square" }}>Recognition of Academic Excellence with cash prizes</li>
                <li style={{ listStyleType: "square" }}>Inspirational Speeches by Political Leaders</li>
                <li style={{ listStyleType: "square" }}>Oath-Taking Ceremony for Ethical Practice</li>
              </ul>
            </p>
            <p style={{ color: "#00072D", marginTop: "-20px" }}>
              The convocation symbolizes our students’ readiness to uphold
              healthcare standards with compassion, professionalism, and
              integrity.
            </p>

            <h5 style={{ color: "red", fontWeight: "bold" }}>
              Shaping the Medical & Healthcare Leaders of Tomorrow
            </h5>

            <p style={{ color: "#00072D" }}>
              Our alumni continue to make meaningful contributions to
              society—whether in hospitals, rural healthcare services, or
              advanced medical facilities. Their dedication strengthens the
              healthcare system and improves countless lives.
            </p>

            <h5 style={{ color: "red", fontWeight: "bold" }}>
              Join the Next Batch of Success Stories
            </h5>

            <p style={{ color: "#00072D" }}>
              If you aspire to build a respected career in medical and
              healthcare services, become part of our next training class and
              start your journey toward a rewarding future in healthcare.
            </p>
          </Row>
        </Container>
      </div>
    );
  }
}
